export default __webpack_public_path__ + "static/media/card-img.1d7baed9.png";